import React, {useState} from 'react';
import Section from "../../../components/section/Section";
import Th_title from "../../../components/Th_title";
import {CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {
    DetailFormPageShell,
    DetailListPage,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {validation} from "../../serviceRequest/serviceRequest/serviceUtils";
import {requestRentalRequest} from "../../../api/lifecycle/rental/rentalRequestService";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";

const RentalRequestUserCreate = () => {
    const [assets, setAssets] = useState([]);
    const [rentalRequest, setRentalRequest] = useState({
        startDate: dayjs(new Date()).format('YYYY-MM-DDT23:59:59'),
        endDate: dayjs(new Date()).format('YYYY-MM-DDT23:59:59')
    });

    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleRequestRentalRequest = async () => {
        const data = {
            rentalAssetIds: assets.map(asset => asset.id),
            startDate: rentalRequest.startDate,
            endDate: rentalRequest.endDate
        }
        if (!validation(data, t)) return;
        await requestRentalRequest(data, () => {
            window.alert(t(`done`));
            navigate('/lifecycle/rentalRequestUser/list');
        });
    }

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout"
            title="대여자산관리"
            meta="라이프사이클 > 자산대여관리 > 등록"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/lifecycle/rentalRequestUser/list")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                handleRequestRentalRequest();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <div className="asset-detail-list-scroll detail-list-scroll">
            <Section title={"대여자산 신청"}>
                <table className="w-full create-table">
                    <tbody>
                    <tr>
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top" required={true}>
                            <UserSelectionField
                                layout="inline"
                                data={assets}
                                countUnit="개"
                                chipEntity="asset"
                                listModalTitle="자산목록"
                                onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                            >
                                <SearchSelector
                                    auth
                                    multiSelect
                                    variant="compact"
                                    entity={ContentCategory.RENTAL_ASSET}
                                    uniqueKey={ContentCategory.RENTAL_ASSET}
                                    data={assets}
                                    onChange={(v) => {
                                        if (v?.__multiFlat) setAssets(v.__multiFlat);
                                    }}
                                >
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"자산명"}/>
                                    <SimmsDrawerSearch showLabel title={'대여자산그룹'} entity={'code'} target={'rentalAssetCode'}
                                                       parentKey={CodeSpecNum.RentalAssetCode} uniqueKey={'rentalAssetCode'}
                                                       recursive/>
                                </SearchSelector>
                            </UserSelectionField>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"대여 시작일"} colspan={3} className="fieldset-td relative align-top" required={true}>
                            <div>
                                <SimmsDatePicker readonly data={rentalRequest.startDate}/>
                            </div>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"대여 종료일"} colspan={3} className="fieldset-td relative align-top" required={true}>
                            <div>
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setRentalRequest, "endDate", v, true)}
                                    constraint={{largerThan: dayjs(new Date()), required: true, autoClose: true}}
                                    data={rentalRequest.endDate} auth/>
                            </div>
                        </Th_title>
                    </tr>
                    </tbody>
                </table>
            </Section>
                    </div>
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
};

export default RentalRequestUserCreate;